'use strict';

import { getEntityTags } from 'App/services/EntityTags';
import {
	flattenMailTagList,
	generateFormSubmitTags,
	getMailTagCatalogue,
	getMailTagList,
	getMailTags,
	getSocialEventTags,
	getTagsByEntity2
} from 'App/services/MailTags';

// Merger the services when time is on our side!

angular.module('services.tagService', []).service('TagService', [
	'$translate',
	function ($translate) {
		var instance = {};

		var getTag = function (tag, title, raw, html) {
			return {
				name: title,
				value: raw ? tag : '{{' + tag + '}}',
				html: html || false
			};
		};

		var getTagBee = function (tag, title, raw) {
			var tRaww;
			if (raw) {
				tRaww = tag.replace('{{', '[[').replace('}}', ']]');
			}
			return {
				name: title,
				value: raw ? tRaww : '[[' + tag + ']]'
			};
		};

		instance.translate = function (entity, entityId, obj) {
			if (!entity || typeof entity !== 'string') {
				return 'Requires entity as string';
			}

			if (!entityId || typeof entityId !== 'number') {
				return 'Requires entityId as number';
			}

			return Tools.Function.translateTags({
				data: obj,
				entity: entity,
				entityId: entityId
			});
		};

		instance.getTagsBee = function () {
			return _.sortBy(
				_.map(getMailTagCatalogue().tags, function (tag) {
					return getTagBee(tag.tag, $translate.instant(tag.lang), tag.raw);
				}),
				'name'
			);
		};

		instance.getTags = function () {
			return _.sortBy(
				_.map(getMailTagCatalogue().tags, function (tag) {
					return getTag(tag.tag, $translate.instant(tag.lang), tag.raw, tag.html);
				}),
				'name'
			);
		};

		// Delegates to the standalone so Angular and React share ONE catalogue.
		instance.getMailTags = getMailTags;
		instance.getSocialEventTags = getSocialEventTags;

		return instance;
	}
]);

angular.module('services.tagService').service('TagsService', [
	function () {
		var instance = {};

		// Delegates to the standalone so Angular and React share ONE catalogue.
		// upCustomField.js still reaches getTagsByEntity through Tools.TagsService.
		instance.getTagsByEntity = getEntityTags;
		instance.getTagsByEntity2 = getTagsByEntity2;
		instance.generateFormSubmitTags = generateFormSubmitTags;
		instance.getMailTagList = getMailTagList;
		instance.flattenMailTagList = flattenMailTagList;

		return instance;
	}
]);
